// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lista-comentarios-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 1rem;
    padding: .5rem 1rem;
    border-radius: 8px;
    background-color: var(--branco-padrao);
    box-shadow: 0 0 1rem rgba(0, 0, 0, .15);
    margin-bottom: 10rem;
}

.lista-comentarios-do-chamado {
    display: flex;
    flex-direction: column;
    width: 100%;
    list-style: none;
    gap: .4rem;
}

.comentario-chamado {
    display: flex;
    align-items: flex-start;
    justify-content: left;
    border-radius: 8px;
}

.nome-usuario-comentario {
    font-size: 1rem;
    font-weight: 600;
    color: var(--azul-dixi);
}

.avatar-usuario-comentario img {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 0.6rem;
    margin-top: 0.15rem;
}

.info-usuario-e-texto-container {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
    padding: .6rem 1rem;
    border-radius: 8px;   
    background-color: var(--cinza-fundo-input-padrao2);
    position: relative;
    gap: 0.5rem;
}

.conteudo-comentario-chamado {
    width: 100%;
    min-height: 36px;
    white-space: pre-wrap;
    font-size: 1rem;
    margin-top: 0.4rem;
    word-break: break-word;
}

#is-proprio {
    background-color: var(--azul-fundo-comentario-proprio);
    color: var(--texto-azul-comentario-proprio);
}

.is-proprio-texto {
    color: var(--texto-azul-comentario-proprio);
}

#detalhe-comentario-container {
    position: absolute;
    justify-content: space-between; 
    flex-wrap: wrap;
    margin-top: auto;
    right: 5px;
    bottom: 8px;
}

#tipo-comentario {
    font-size: .7rem;
    font-weight: 500;
    color: var(--branco-padrao);
    background-color: var(--texto-azul-comentario-proprio);
    padding: .2rem .6rem;
    border-radius: 12px;
    margin-right: 0.5rem;
}

.estilo-data-comentario {
    font-size: .8rem;
    font-weight: 600;
    
}

#data-comentario {
    color: var(--cinza-label-input-padrao);
}

#data-comentario-proprio {
    color: var(--texto-azul-comentario-proprio);
}
`, "",{"version":3,"sources":["webpack://./src/components/ListaComentarios/ListaComentarios.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,sCAAsC;IACtC,uCAAuC;IACvC,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kDAAkD;IAClD,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,sDAAsD;IACtD,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,sDAAsD;IACtD,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;;AAEpB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2CAA2C;AAC/C","sourcesContent":[".lista-comentarios-container {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    margin-top: 1rem;\n    padding: .5rem 1rem;\n    border-radius: 8px;\n    background-color: var(--branco-padrao);\n    box-shadow: 0 0 1rem rgba(0, 0, 0, .15);\n    margin-bottom: 10rem;\n}\n\n.lista-comentarios-do-chamado {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    list-style: none;\n    gap: .4rem;\n}\n\n.comentario-chamado {\n    display: flex;\n    align-items: flex-start;\n    justify-content: left;\n    border-radius: 8px;\n}\n\n.nome-usuario-comentario {\n    font-size: 1rem;\n    font-weight: 600;\n    color: var(--azul-dixi);\n}\n\n.avatar-usuario-comentario img {\n    width: 2rem;\n    height: 2rem;\n    border-radius: 50%;\n    object-fit: cover;\n    margin-right: 0.6rem;\n    margin-top: 0.15rem;\n}\n\n.info-usuario-e-texto-container {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    width: 100%;\n    height: 100%;\n    padding: .6rem 1rem;\n    border-radius: 8px;   \n    background-color: var(--cinza-fundo-input-padrao2);\n    position: relative;\n    gap: 0.5rem;\n}\n\n.conteudo-comentario-chamado {\n    width: 100%;\n    min-height: 36px;\n    white-space: pre-wrap;\n    font-size: 1rem;\n    margin-top: 0.4rem;\n    word-break: break-word;\n}\n\n#is-proprio {\n    background-color: var(--azul-fundo-comentario-proprio);\n    color: var(--texto-azul-comentario-proprio);\n}\n\n.is-proprio-texto {\n    color: var(--texto-azul-comentario-proprio);\n}\n\n#detalhe-comentario-container {\n    position: absolute;\n    justify-content: space-between; \n    flex-wrap: wrap;\n    margin-top: auto;\n    right: 5px;\n    bottom: 8px;\n}\n\n#tipo-comentario {\n    font-size: .7rem;\n    font-weight: 500;\n    color: var(--branco-padrao);\n    background-color: var(--texto-azul-comentario-proprio);\n    padding: .2rem .6rem;\n    border-radius: 12px;\n    margin-right: 0.5rem;\n}\n\n.estilo-data-comentario {\n    font-size: .8rem;\n    font-weight: 600;\n    \n}\n\n#data-comentario {\n    color: var(--cinza-label-input-padrao);\n}\n\n#data-comentario-proprio {\n    color: var(--texto-azul-comentario-proprio);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
